import React from "react";
import FooterSection from "./FooterSection";
import "../styles/fonts.css";


const Career = () => {
  // Embed URL for the Google Form (replace with your live form URL)
  const googleFormUrl = "https://docs.google.com/forms/d/e/1FAIpQLScWWH11cxRG71R-msKDFH1lAQ1ETpSEUGJef1GfZzFhGuwqpg/viewform?embedded=true";

  return (
    <>
  <section className="w-full pt-[120px] md:pt-[200px] px-4 sm:px-6 font-inter md:pl-[350px] scale-100 md:scale-[1.15] bg-transparent">
      {/* Top Label */}
  <div className="max-w-[1100px] mx-auto flex flex-col items-start md:mt-[35px]">
          <div className="flex items-center justify-center gap-2 mb-3 ml-[10px] mr-[10px] border border-dashed border-neutral-300 shadow-sm h-[31px] w-[90px] mx-auto rounded-[40px] bg-white">
            <svg width="10" height="10" viewBox="0 0 256 256" fill="#3C5DF7" className="animate-spin" style={{ animationDuration: "5s" }}>
              <path d="M240,128a15.79,15.79,0,0,1-10.5,15l-63.44,23.07L143,229.5a16,16,0,0,1-30,0L89.94,166.06,26.5,143a16,16,0,0,1,0-30L89.94,89.94,113,26.5a16,16,0,0,1,30,0l23.07,63.44L229.5,113A15.79,15.79,0,0,1,240,128Z" />
            </svg>
            <span className="text-black font-medium text-[13px]">Contact</span>
          </div>

        {/* Heading */}
        <h1 className="text-[48px] md:text-[50px] font-[630] leading-[1.05] text-center md:text-left tracking-tight">
          Start Your{" "}
          <span className="text-[#3C5DF7] recoleta">Next</span>
          <br />
          <span className="text-[#3C5DF7] recoleta">Career</span> <span className="recoleta">With Us</span>
        </h1>

        <p className="text-left text-[13.5px] text-[#555] max-w-[420px] mt-[10px] mb-[47px] leading-[1.6] font-[600] mx-0 self-start">
          Got a project in mind or just want to say hi? Fill out the form and we'll get back to you shortly.
        </p>

        {/* Google Form Container (replaces local form) */}
        <div
          className="
            mt-[10px] p-6 
            rounded-[22px]
            border border-dashed border-gray-300 
            bg-white 
            shadow-sm
            md:min-w-[750px]
            max-w-[1050px]
            mb-[250px]
            h-[1275px]
            w-full
            md:w-auto
            background:transparent
            self-start
          "
        >
          <iframe
            src={googleFormUrl}
            style={{
              border: 0,
              width: "100%",
              height: "1200px",
              borderRadius: "18px",
            }}
            loading="lazy"
            frameBorder="0"
            title="Career Application Form"
          />
          <p className="text-center text-gray-500 text-[14px] mt-0">
            Fill out the form above — we’ll get back to you shortly.
          </p>
        </div>
      </div>
    </section>
    <FooterSection />
    </>
  );
};

export default Career;
